// Texto 28 (C2): fotos dentro de um relatório em PDF, REDUZIDAS (lado maior ~1000 px, JPEG 60%), para o PDF ficar leve
// (algo como 2 a 3 MB com 12 fotos). Nada é guardado: a foto reduzida existe só na memória enquanto o PDF é montado
// (a cópia temporária do sistema, quando existe, é apagada logo depois).
import { Image, Platform } from 'react-native';
import type { Anexo } from '../store/types';
import { lerBase64, temLocal } from './anexos';
import { urlGrupo } from './arquivosGrupo';

const bytesDe = (b64: string) => { const bin = atob(b64); const u = new Uint8Array(bin.length); for (let i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i); return u; };
const temManipulador = () => Platform.OS === 'web' || !!(globalThis as any).expo?.modules?.ExpoImageManipulator;
export const ehFoto = (a: Anexo) => !!a.mime?.startsWith('image/') && !a.cofre;

/** Endereço de onde ler a foto (neste aparelho, embutida ou na pasta do grupo). */
async function origem(a: Anexo): Promise<string | null> {
  if (a.dado) return a.dado;
  if (temLocal(a) && a.uri) return a.uri;
  if (a.gp) return urlGrupo(a.gp);
  if (a.url && /^https?:/i.test(a.url)) return a.url;
  return null;
}

/** Bytes JPEG da foto reduzida (ou null, se não der para ler a foto aqui). */
export async function fotoReduzida(a: Anexo, LADO = 1000, qualidade = 0.6): Promise<Uint8Array | null> {
  const src = await origem(a).catch(() => null);
  if (!src) return null;
  if (temManipulador()) {
    try {
      const IM = require('expo-image-manipulator');
      // só diminui (foto pequena não é ampliada); o lado maior fica com até 1000 px
      const tam = await new Promise<{ w: number; h: number } | null>(res => Image.getSize(src, (w, h) => res({ w, h }), () => res(null)));
      const passo = !tam ? [{ resize: { width: LADO } }] : Math.max(tam.w, tam.h) <= LADO ? [] : tam.w >= tam.h ? [{ resize: { width: LADO } }] : [{ resize: { height: LADO } }];
      const r = await IM.manipulateAsync(src, passo, { compress: qualidade, format: IM.SaveFormat.JPEG, base64: true });
      if (r?.uri && Platform.OS !== 'web') {
        try { const { File } = require('expo-file-system'); const f = new File(r.uri); if (f.exists) f.delete(); } catch { /* o sistema limpa depois */ }
      }
      if (r?.base64) return bytesDe(r.base64);
    } catch { /* segue: tenta a foto como está, se for pequena */ }
  }
  try {
    const b64 = a.dado || temLocal(a) ? await lerBase64(a) : null;
    const bytes = b64 ? bytesDe(b64) : new Uint8Array(await (await fetch(src)).arrayBuffer());
    return bytes.length <= 900 * 1024 ? bytes : null;   // sem como reduzir: só entra se já for leve
  } catch { return null; }
}

/** Sugestão do app: até n fotos espalhadas pela viagem (a primeira, a última e as do meio). */
export function sugerirFotos<T>(lista: T[], n = 12): T[] {
  if (lista.length <= n) return lista;
  const out: T[] = [];
  for (let i = 0; i < n; i++) out.push(lista[Math.round((i * (lista.length - 1)) / (n - 1))]);
  return [...new Set(out)];
}

/** Bytes de qualquer anexo (guardado aqui, embutido, na pasta do grupo ou link https). null se não der para ler aqui. */
export async function bytesDoAnexo(a: Anexo): Promise<Uint8Array | null> {
  try {
    if (a.dado || temLocal(a) || a.cofre) return bytesDe(await lerBase64(a));
    const src = await origem(a);
    if (!src) return null;
    return new Uint8Array(await (await fetch(src)).arrayBuffer());
  } catch { return null; }
}
